require("reading/shelves/my_shelf_page.scss");

var CurrentUser = require("lib/account/CurrentUser");
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { provideLocationState } from "components/utility/hoc/LocationState";

var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");

var BookShelf = require("components/reading/shelves/BookShelf");
var Spinner = require("components/utility/Spinner");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var LogCalendar = require('components/reading/logs/LogCalendar');
var AllMonthsLogTable = require('components/reading/logs/AllMonthsLogTable');
var Features = require('lib/account/Features');
var MyWorkDisplay = require('components/reading/shelves/MyWorkDisplay')

var MyShelfRouting = require("lib/routing/MyShelfRouting");

@provideLocationState(MyShelfRouting.getRouteState)
@connect(
	(state, props) => {
		// TODO: Pass books in from reswift too
		// TODO: Only pass logs for the current view
		var userID = CurrentUser.get().id;

		return {
			logs: ReadingSelectors.logs({ state, conditions: { userID: userID } }),
			isLoadingLogs: ReadingSelectors.isLoadingLogs({ state })
		}
	},
	(dispatch, props) => {
		var userID = CurrentUser.get().id;

		return {
			populateLogs: () => dispatch(ReadingActions.fetchLogs({
				conditions: { userID: userID }
			}))
		}
	}
)

class MyShelfPage extends React.Component {

	constructor(props) {
		super();
		autobind(this);

		this.state = {
			view: SHELF_VIEW,

			books: null, loading: false
		};
	}

	switchActiveView(viewKey) {
		Mycroft.newEvent({ category: "Class Page", action: "toggle-view", label: viewKey });
		this.switchView({ activeView: viewKey });
	}

	switchView(change) {
		var locationState = { ...this.props.locationState }
		if (change.backToShelf) {
			locationState.activeView = MyShelfRouting.VIEWS.SHELF_VIEW
			change = { textID: undefined }
		}
		var newLocationState = _.extend({}, locationState, change);
		if (newLocationState.activeView === 'work' && newLocationState.detailsView === undefined) {
			newLocationState.detailsView = 'quizzes'
		}
		$wr.redirect(MyShelfRouting.getPath(newLocationState));
	}

	// routeParams(props) {
	// 	props = props || this.props;
	// 	if (props && props.match) {
	// 		return props.match.params || {};
	// 	} else {
	// 		return {};
	// 	}
	// }

	// routeActiveView(props) {
	// 	var params = this.routeParams(props);

	// 	if (params.active_view == "shelf") {
	// 		return SHELF_VIEW;
	// 	} else if (params.active_view == "reading") {
	// 		return LOGS_VIEW;
	// 	}
	// }
	// isLogView() {
	// 	return !this.isShelfView();
	// }

	// routeDetailsView(props) {
	// 	return this.routeParams(props).details_view;
	// }

	// routeTextID(props) {
	// 	return this.routeParams(props).text_id;
	// }

	// onViewChange(activeView) {
	// 	this.switchView(activeView);
	// }

	// switchView(activeView, detailsView, textID) {
	// 	if (this.state.loading) { return; }
	// 	if (detailsView && textID) {
	// 		$wr.redirect("/my/" + activeView + "/" + detailsView + "/" + textID);
	// 	} else {
	// 		$wr.redirect("/my/" + activeView);
	// 	}
	// }

	isShelfView() {
		return this.props.locationState.activeView == MyShelfRouting.VIEWS.SHELF_VIEW;
	}
	isWorkView() {
		return this.props.locationState.activeView == MyShelfRouting.VIEWS.WORK_VIEW;
	}

	loadBooks() {
		// You might want to use these embeds at some point, but they're technically not needed now:
		// "book.average_rating"
		var params = {
			user_id: CurrentUser.get().id,
			order: "desc-last-active",
			draft: true,
			merge_text_data: true,
			embed: "book.quiz_user_ids,book.quiz_draft_user_ids"
		}

		this.setState({ loading: true });
		CurrentUser.api().getBooks(params, $wr.apiHandler(function (response) {
			var books = (this.state.books || []).concat(response.books);
			this.setState({ books: books, loading: false });
		}.bind(this)));
	}

	render() {
		var lState = this.props.locationState;

		var pageClassName = "container myShelfPage";

		var toggleOptions = [
			{ key: MyShelfRouting.VIEWS.SHELF_VIEW, text: "My Books" },
			{ key: MyShelfRouting.VIEWS.WORK_VIEW, text: "My Work" }
		]

		if (Features.isEnabled(Features.LOG_READING)) {
			toggleOptions.unshift({ key: MyShelfRouting.VIEWS.LOGS_VIEW, text: "My Reading" })
		}
		var displayToggleOptions = '';
		if (!this.isWorkView()) {
			displayToggleOptions = (
				<div className="hideOnPrint">
					<DisplayToggleControl options={toggleOptions} className="topToggle"
						onChange={this.switchActiveView}
						activeOptionKey={lState.activeView} />
				</div>
			);
		}

		pageClassName += " withToggle";


		if (this.isShelfView()) {
			var pageContent = (
				<BookShelf detailsView={lState.detailsView}
					textID={lState.textID}
					switchView={this.switchView} />
			);

		} else if (this.isWorkView()) {
			var pageContent = (<MyWorkDisplay detailsView={lState.detailsView}
				switchView={this.switchView} />)
		} else {
			if (this.props.isLoadingLogs) {
				var pageContent = (
					<Spinner placeholder={true} scale={1.7} className="shelfSpin" />
				);

			} else {
				var pageContent = (
					<div className="logsWrap">
						<LogCalendar logs={this.props.logs} />
						<AllMonthsLogTable logs={this.props.logs} />
					</div>
				);
			}

		}

		return (
			<div className={pageClassName}>
				<div className="headerSection clearfix">
					<header className="pageHeader">
						<h1 className="hideOnPrint">My Shelf</h1>
					</header>
					{ displayToggleOptions }
				</div>

				{ pageContent}
			</div>
		);
	}

	componentDidUpdate(prevProps) {
		if ($wr.didParamsChange(prevProps, this.props)) {
			this.loadPageContent();
		}
	}

	componentDidMount() {
		this.loadPageContent();
	}

	loadPageContent() {
		if (!this.isShelfView()) {
			this.props.populateLogs();
		}
	}

}

MyShelfPage.WrappedComponent.propTypes = PageStrictPropTypes({
	locationState: PropTypes.object,

	// From @connect
	logs: PropTypes.array,
	isLoadingLogs: PropTypes.bool,
	populateLogs: PropTypes.func
});

var SHELF_VIEW = "shelf";
var LOGS_VIEW = "reading";

module.exports = MyShelfPage;


// WEBPACK FOOTER //
// ./modules/components/reading/shelves/MyShelfPage.js